var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManageCmsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2496_1390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33331 2.98462H2.66665C2.31302 2.98462 1.97389 3.12509 1.72384 3.37514C1.47379 3.62519 1.33331 3.96433 1.33331 4.31795V13.6513C1.33331 14.0049 1.47379 14.344 1.72384 14.5941C1.97389 14.8441 2.31302 14.9846 2.66665 14.9846H12C12.3536 14.9846 12.6927 14.8441 12.9428 14.5941C13.1928 14.344 13.3333 14.0049 13.3333 13.6513V8.98462",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3334 1.98453C12.5986 1.71931 12.9583 1.57031 13.3334 1.57031C13.7084 1.57031 14.0682 1.71931 14.3334 1.98453C14.5986 2.24974 14.7476 2.60945 14.7476 2.98453C14.7476 3.3596 14.5986 3.71931 14.3334 3.98453L8.00004 10.3179L5.33337 10.9845L6.00004 8.31786L12.3334 1.98453Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2496_1390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.317871)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageCmsIcon);
export default __webpack_public_path__ + "static/media/manage_cms_icon.071bbadff491e5ed04e34e2092ed381b.svg";
export { ForwardRef as ReactComponent };